/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 에러코드 예외클래스를 정의한다.
 *
 * @file /src/exceptions/Code.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 7. 4.
 */
import { Base } from './Base';
import { Results } from '@utils/Ajax';
import { Language, LanguageText } from '@utils/Language';

export class Code extends Base {
    /**
     * 치환자
     */
    placeholders: { [key: string]: string };

    /**
     * 추가메시지
     */
    footnote: string = null;

    /**
     * 에러데이터
     */
    errors: { [key: string]: any } = null;

    /**
     * 에러코드 예외클래스를 정의한다.
     *
     * @param code - 에러코드
     * @param placeholders - 치환자
     * @param footnote - 추가메시지
     * @param errors - 에러데이터
     * @param cause - 에러객체 또는 에러응답객체
     */
    constructor(
        code: string,
        placeholders: { [key: string]: string } = null,
        footnote: string = null,
        errors: { [key: string]: any } = null,
        cause: Error | Results = null
    ) {
        super(cause);
        this.name = this.constructor.name;
        this.code = code;
        this.placeholders = placeholders;
        this.footnote = footnote;
        this.errors = errors;
    }

    /**
     * 에러데이터를 가져온다.
     *
     * @returns 에러데이터
     */
    getErrors(): { [key: string]: any } {
        return this.errors;
    }

    /**
     * 에러응답객체를 가져온다.
     *
     * @return 에러응답객체
     */
    getResponse(): Results {
        if (this.cause instanceof Error) {
            return null;
        }

        if (typeof this.cause == 'object') {
            return this.cause as Results;
        }

        return null;
    }

    /**
     * 에러메시지를 가져온다.
     *
     * @returns 에러메시지
     */
    getMessage(): LanguageText {
        return this.footnote ?? Language.getError(this.code, this.placeholders);
    }
}
